import {
    useGetPastBookingsWithPagination,
    useGetHasSelections,
    useGetFutureBookings,
    useGetCanceledBookingsWithPages,
    useCard,
} from "modules/ClientAccount/hooks"
import { Spinner } from "components/Spinner"
import { GoToSelectionsCard, GoToSurveyCard } from "modules/ClientAccount/components/GoToCard"
import { Button } from "ui-kit/components-branded/index"
import { FAQContainer } from "modules/ClientAccount/components/FAQContainer"
import { CertificateBlock, CourseBanner } from "components"
import { toSession } from "modules/ClientAccount/utils"
import { BrowserWarningBanner, BrowserWarningType } from "components/BrowserWarningBanner"
import { SignUpAgainCard } from "modules/ClientAccount/components/Sessions/SignUpAgainCard"
import { Sessions } from "modules/ClientAccount/components/Sessions/index"

export function MySessionsList() {
    const { data: featureBookings = [] } = useGetFutureBookings()
    const { data: hasListings, isLoading: hasListingsLoading } = useGetHasSelections()

    const {
        showSignUpAgainCard,
        isSessionPlanning,
        signUpAgainCardPsy,
        showGoToCard,
        cardLoading,
    } = useCard()

    if (hasListingsLoading || cardLoading) return <Spinner />

    return (
        <>
            {showSignUpAgainCard && signUpAgainCardPsy && (
                <SignUpAgainCard psy={signUpAgainCardPsy} isSessionPlanning={isSessionPlanning} />
            )}
            {showGoToCard && (hasListings ? <GoToSelectionsCard /> : <GoToSurveyCard />)}
            {featureBookings[0]?.psy.experimental_group_member &&
                featureBookings[0]?.service_type.online && (
                    <BrowserWarningBanner
                        type={BrowserWarningType.UpcommingSession}
                        className="client-account__browser-warning"
                    />
                )}
            {featureBookings.length > 0 && (
                <Sessions sessions={featureBookings.map((b) => toSession(b))} />
            )}
            <PastSessionsList />
            <div className="banner-mobile is-hidden-tablet">
                <CertificateBlock />
                <CourseBanner />
            </div>
            <FAQContainer />
        </>
    )
}

export function PastSessionsList() {
    const { isFetchingNextPage, fetchNextPage, hasNextPage, data, isFetching, hasPastBooking } =
        useGetPastBookingsWithPagination()

    if (!hasPastBooking) return null

    return (
        <>
            <div className="past-sessions__headline">Прошедшие сессии</div>
            {data?.pages.map((page, index) => (
                <Sessions key={index} sessions={page.results.map((b) => toSession(b))} />
            ))}
            {hasNextPage && (
                <Button
                    className="past-sessions__load-more-button is-fullwidth"
                    onClick={() => {
                        hasNextPage && void fetchNextPage()
                    }}
                    disabled={!hasNextPage}
                    isLoading={isFetching || isFetchingNextPage}
                >
                    Показать еще
                </Button>
            )}
        </>
    )
}

export function CanceledSessionsList() {
    const { isFetchingNextPage, fetchNextPage, hasNextPage, data, isFetching, isFetched } =
        useGetCanceledBookingsWithPages()
    if (!isFetched) return <Spinner />
    return (
        <>
            {data?.pages.map((page, index) => (
                <Sessions key={index} sessions={page.results.map((b) => toSession(b))} />
            ))}
            {hasNextPage && (
                <Button
                    isFullwidth
                    onClick={() => {
                        hasNextPage && void fetchNextPage()
                    }}
                    disabled={!hasNextPage}
                    isLoading={isFetching || isFetchingNextPage}
                >
                    Показать еще
                </Button>
            )}
        </>
    )
}
